import { render, staticRenderFns } from "./EmailSignup.vue?vue&type=template&id=37b3e3dd&scoped=true"
import script from "./EmailSignup.vue?vue&type=script&lang=js"
export * from "./EmailSignup.vue?vue&type=script&lang=js"
import style0 from "./EmailSignup.vue?vue&type=style&index=0&id=37b3e3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3e3dd",
  null
  
)

export default component.exports